import { render, staticRenderFns } from "./PackagesApprove.vue?vue&type=template&id=1acae72a&scoped=true&"
import script from "./PackagesApprove.vue?vue&type=script&lang=js&"
export * from "./PackagesApprove.vue?vue&type=script&lang=js&"
import style0 from "./PackagesApprove.vue?vue&type=style&index=0&id=1acae72a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acae72a",
  null
  
)

export default component.exports